import React from 'react';
import { Autocomplete } from '@react-google-maps/api';
import { Input, Box, Text, List, ListItem } from '@chakra-ui/react';

const AddressAutocomplete = ({ value, onChange, placeholder, onLocationSelect }) => {
  const [autocomplete, setAutocomplete] = React.useState(null);
  const [addressDetails, setAddressDetails] = React.useState(null);
  const [predictions, setPredictions] = React.useState([]);
  const [showPredictions, setShowPredictions] = React.useState(false);

  const onLoad = (autocomplete) => {
    setAutocomplete(autocomplete);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    onChange(value);

    if (value.length > 2) {
      const service = new window.google.maps.places.AutocompleteService();
      service.getPlacePredictions(
        {
          input: value,
          componentRestrictions: { country: 'ma' }
        },
        (predictions, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            setPredictions(predictions);
            setShowPredictions(true);
          } else {
            setPredictions([]);
            setShowPredictions(false);
          }
        }
      );
    } else {
      setPredictions([]);
      setShowPredictions(false);
    }
  };

  const handlePredictionClick = (prediction) => {
    const service = new window.google.maps.places.PlacesService(document.createElement('div'));
    service.getDetails(
      {
        placeId: prediction.place_id,
        fields: ['address_components', 'formatted_address', 'geometry', 'name']
      },
      (place, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          let streetNumber = '';
          let route = '';
          let postalCode = '';
          let city = '';
          let formattedAddress = '';
          let location = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          };

          place.address_components.forEach(component => {
            const types = component.types;

            if (types.includes('street_number')) {
              streetNumber = component.long_name;
            } else if (types.includes('route')) {
              route = component.long_name;
            } else if (types.includes('postal_code')) {
              postalCode = component.long_name;
            } else if (types.includes('locality')) {
              city = component.long_name;
            }
          });

          if (streetNumber && route) {
            formattedAddress = `${streetNumber} ${route}`;
            if (postalCode && city) {
              formattedAddress += `, ${postalCode} ${city}`;
            }
          } else {
            formattedAddress = place.formatted_address;
          }

          const addressData = {
            streetNumber,
            route,
            postalCode,
            city,
            formattedAddress,
            placeId: place.place_id,
            location: location,
            name: place.name
          };

          setAddressDetails(addressData);
          onChange(formattedAddress);
          
          // Appeler la fonction de callback avec les données de localisation
          if (onLocationSelect) {
            onLocationSelect(addressData);
          }
          
          setShowPredictions(false);
        }
      }
    );
  };

  return (
    <Box position="relative">
      <Input
        type="text"
        value={value}
        onChange={handleInputChange}
        placeholder={placeholder}
        w="100%"
        onFocus={() => value.length > 2 && setShowPredictions(true)}
        onBlur={() => setTimeout(() => setShowPredictions(false), 200)}
      />
      
      {showPredictions && predictions.length > 0 && (
        <List
          position="absolute"
          zIndex={1000}
          width="100%"
          bg="white"
          boxShadow="md"
          borderRadius="md"
          mt={1}
          maxH="200px"
          overflowY="auto"
        >
          {predictions.map((prediction) => (
            <ListItem
              key={prediction.place_id}
              p={2}
              cursor="pointer"
              _hover={{ bg: 'gray.100' }}
              onClick={() => handlePredictionClick(prediction)}
            >
              {prediction.description}
            </ListItem>
          ))}
        </List>
      )}

      {addressDetails && (
        <Text fontSize="sm" color="gray.500" mt={1}>
          {addressDetails.formattedAddress}
        </Text>
      )}
    </Box>
  );
};

export default AddressAutocomplete; 
